export default __webpack_public_path__ + "static/media/76t.babdce01.jpg";